export default __webpack_public_path__ + "04f24dfcb5bb703c6a1daddc0c046158.svg";